import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class OperationApi {
  static async GetAllOperation(): Promise<any> {
    return ApiHandler(baseURL).get("/operation/getalloperation");
  }

  static async Create(operationData: {
    name: string;
    description: string;
    rank: number;
    isActive: boolean;
    subLineId: string;
    operationTypeId: string;
  }): Promise<any> {
    return ApiHandler(baseURL).post(
      "/operation/createoperation",
      operationData,
    );
  }
  static async GetById(culture: string, id: number): Promise<any> {
    return ApiHandler(baseURL).get(
      culture + "/operation/getoperationbyid/" + id,
    );
  }

  static async Delete(id: string): Promise<any> {
    return ApiHandler(baseURL).post(`/operation/deleteoperation?Id=${id}`);
  }

  static async GetByFailureId(failureId: string): Promise<any> {
    return ApiHandler(baseURL).get(
      `/operation/getbyfailureid?failureId=${failureId}`,
    );
  }

  static async GetByFilter(
    plantIds: string[] = [],
    pageNumber: number = 1,
    pageSize: number = 10,
    sortField: string = "name",
    sortDirection: string = "asc",
    name?: string,
    description?: string,
    rank?: number,
    isActive?: boolean,
    productionUnitIds: string[] = [],
    areaIds: string[] = [],
    lineIds: string[] = [],
    subLineIds: string[] = [],
    operationTypeIds: string[] = [],
  ): Promise<any> {
    const params = new URLSearchParams();

    // Arrays com múltiplos valores (usando a mesma chave várias vezes)
    plantIds.forEach((id) => params.append("plantIds", id));
    productionUnitIds.forEach((id) => params.append("productionUnitIds", id));
    areaIds.forEach((id) => params.append("areaIds", id));
    lineIds.forEach((id) => params.append("lineIds", id));
    subLineIds.forEach((id) => params.append("subLineIds", id));
    operationTypeIds.forEach((id) => params.append("operationTypeIds", id));

    // Filtros simples
    params.append("pageNumber", pageNumber.toString());
    params.append("pageSize", pageSize.toString());
    params.append("sortField", sortField);
    params.append("sortDirection", sortDirection);

    if (name) params.append("name", name);
    if (description) params.append("description", description);
    if (rank !== undefined) params.append("rank", rank.toString());
    if (isActive !== undefined) params.append("isActive", isActive.toString());

    const url = `/operation/getoperationsbyfilter?${params.toString()}`;

    return ApiHandler(baseURL).get(url);
  }

  static async GetOperationsBySubLineId(subLineId: string): Promise<any> {
    const url = `/operation/GetOperationsBySubLineId/${subLineId}`;
    return ApiHandler(baseURL).get(url);
  }

  static async GetAllOperationTypes(): Promise<any> {
    return ApiHandler(baseURL).get(`/operationtype/getalloperationtype`);
  }

  static async GetOperationById(id: string): Promise<any> {
    return ApiHandler(baseURL).get(`/operation/getoperationbyid?Id=${id}`);
  }

  static async GetOperationDetailsById(id: string): Promise<any> {
    return ApiHandler(baseURL).get(
      `/operation/getoperationdetailsbyid?Id=${id}`,
    );
  }

  static async Update(data: {
    id: string;
    name: string;
    description: string;
    isactive: boolean;
    rank: number;
    subLineId: string;
    operationTypeId: string;
  }): Promise<any> {
    return ApiHandler(baseURL).post("/operation/updateoperation", data);
  }

}
